import { useContentfulLiveUpdates } from "@contentful/live-preview/react"
import { getAllResourcesData } from "../../lib/api"
import { fetchRecommended } from "../../lib/fetchRecommended"
import FilterGridTemplate from "@templates/filter-grid"
import FlexibleData from "@lib/flexibleData"

// ---------------------------------------------------------

export async function getStaticProps(context) {
  const preview = process.env.NODE_ENV === "development" || context.draftMode || false
  const previewEnv = context?.previewData?.environment || null
  const pageData = (await FlexibleData.fetch("resources", preview, previewEnv)) ?? []
  const resourcesData = (await getAllResourcesData(preview)) ?? []

  const typesSet = new Set()
  const industriesSet = new Set()
  const tagSet = new Set()

  resourcesData.forEach((resource) => {
    if (resource?.types) typesSet.add(resource.types)
    if (resource?.tags) {
      resource.tags.forEach((tag) => {
        if (tag.includes("Industry:")) {
          const cleanTag = tag.replace("Industry:", "").trim()
          industriesSet.add(cleanTag)
        } else {
          tagSet.add(tag)
        }
      })
    }
  })

  const dropdownOptions = {
    industries: [...industriesSet].sort((a, b) => a.localeCompare(b)),
    tags: [...tagSet].sort((a, b) => a.localeCompare(b)),
    types: [...typesSet].sort((a, b) => a.localeCompare(b))
  }

  const tags = resourcesData.contentfulMetadata?.tags?.map((tag) => {
    return tag.id
  })

  const recommended = pageData.showRecommended
    ? await fetchRecommended(
        pageData?.recommendedCollection?.items,
        "resources",
        "blogs",
        tags,
        preview
      )
    : null

  return {
    props: { pageData, dropdownOptions, resourcesData, recommended, preview }
  }
}

const ResourceIndexPage = (props) => {
  const { dropdownOptions, pageData, preview, recommended, resourcesData } = props

  const livePageData = useContentfulLiveUpdates(pageData)

  return (
    <FilterGridTemplate
      pageData={livePageData}
      contentData={resourcesData}
      dropdownOptions={dropdownOptions}
      recommendedProps={{
        title: "Explore Blogs",
        buttonLabel: "View all blogs",
        buttonUrl: "/blog",
        recommended: recommended
      }}
      preview={preview}
      route={pageData.slug}
      hasTextSearch
    />
  )
}

export default ResourceIndexPage
